module.exports = __webpack_public_path__ + "static/media/dwellPass-emblem-map-purple-shadow-120.7ef37ccd.png";